export function loadScript( src: string ): Promise<void> {
    return new Promise( ( resolve, reject ) => {
        const script = document.createElement( 'script' );
        script.type = 'text/javascript';
        script.async = true;
        script.src = src;
        script.onload = () => resolve();
        script.onerror = () => reject();
        document.body.append( script );
    } );
}
